import React from "react"
import SubServices from "../common/sub-services"

const QaServies = () => {
  return (
    <div className="section-py">
      <div className="container lg:container mx-auto">
        <div className="row grid lg:grid-cols-12">
          <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
            <h2
              className="text-primary mb-2.5"
              data-aos="fade-up"
              data-aos-duration="700"
              data-aos-delay="100"
            >
              Why Outsource QA services
            </h2>
            <p
              className="text-secondary mb-0 fs-mdlg fw-600"
              data-aos="fade-up"
              data-aos-duration="700"
              data-aos-delay="200"
            >
            Outsource your QA services to Moweb to enhance your software quality and avoid the complexities of in-house QA management.
            </p>
          </div>
        </div>
        <div className="row grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 lg:w-8/12 mx-auto">
          <SubServices
            path={"/img/technology/ic-specialized-expertise.svg"}
            height={64}
            width={64}
            alt="Specialized Expertise"
            title="Specialized Expertise"
            serviceName="Specialized Expertise"
            serviceDescription="Access a team of QA specialists with cutting-edge skills."
          />
          <SubServices
            path={"/img/technology/ic-cost-efficiency.svg"}
            height={64}
            width={64}
            alt="Cost Efficiency"
            title="Cost Efficiency"
            serviceName="Cost Efficiency"
            serviceDescription="Trim costs, not quality – outsource for smart savings."
          />
          <SubServices
            path={"/img/technology/ic-flexibility.svg"}
            height={64}
            width={64}
            alt="Flexibility"
            title="Flexibility"
            serviceName="Flexibility"
            serviceDescription="CMS Development is a great choice for creating a robust custom content management system that facilitates the dynamic needs of business organizations."
          />
          <SubServices
            path={"/img/technology/ic-cutting-edge-tool.svg"}
            height={64}
            width={64}
            alt="Cutting-Edge Tools"
            title="Cutting-Edge Tools"
            serviceName="Cutting-Edge Tools"
            serviceDescription="With thousands of free plugins and extensions available along with multiple inbuilt API support, the development of scalable and rich-featured websites is easier with CMS."
          />
        </div>
      </div>
    </div>
  )
}

export default QaServies
